import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody } from '@met/react-components';
import React from 'react';

import { Action, RightActions, Subtitle, Title, Wrapper } from './styled';

const PageHeader = ({ title, subtitle, actions }) => {
  const rightActions =
    actions &&
    actions.map((action, index) => {
      return (
        <Action key={index} onClick={action.onClick}>
          <FontAwesomeIcon icon={action.icon} />
          <span>{action.label}</span>
        </Action>
      );
    });

  return (
    <Card>
      <CardBody>
        <Wrapper>
          <FontAwesomeIcon icon='globe-americas' size='2x' />
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          <RightActions>{rightActions}</RightActions>
        </Wrapper>
      </CardBody>
    </Card>
  );
};

export default React.memo(PageHeader);
